<template>
    <div class="sim">
        <div class="sim-header rounded-t-lg elevation-10">
            <div class="sim-earhole-1 rounded mr-1"></div>
            <div class="sim-earhole-2 rounded-circle"></div>
        </div>
        <div class="sim-body elevation-10 d-flex">
            <img src='../assets/textel_bubble.svg' class="sim-bkg" v-if="showWatermark"/>
            <slot></slot>
        </div>
        <div class="sim-footer rounded-b-lg elevation-10"></div>
    </div>
</template>

<script type="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'Simulator',
  props: {
    showWatermark: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style scoped lang="scss">
.sim {
  display: inline-block;
}
.sim-body, .sim-footer, .sim-header {
  width: 100%;
}
.sim-body {
  background-color: white;
  overflow: auto;
}
.sim-footer, .sim-header {
  height: 1.948em;
  background-color: var(--v-info-base)
}
.sim-header {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sim-earhole-1, .sim-earhole-2 {
  background-color: var(--v-info-darken2);
  height: .487em;
}
.sim-earhole-1 {
  width: 3.247em;
}
.sim-earhole-2 {
  width: .487em;
}
.sim-bkg {
    opacity: 0.1;
    width: 10em;
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
}
</style>
